import { makeSelector } from "../../../testing/index.js";
import { WdioWrapper } from "../../../testing/wdio.js";
import { FilterButtonSelectors } from "../FilterButton/filterButton.selectors.js";
import { InputSelectors } from "../Input/input.selectors.js";
const TestingAttrs = {
  dateInput: "data-date-input",
  filterButton: "data-filter-button",
  clearButton: "data-clear-button",
  applyButton: "data-apply-button",
  cancelButton: "data-cancel-button"
};
const DatePickerSelectors = {
  dateInput: makeSelector("Date input", TestingAttrs.dateInput, InputSelectors.input),
  filterButton: makeSelector("Filter button", TestingAttrs.filterButton),
  clearFilterButton: makeSelector(
    "Clear button in filter button",
    TestingAttrs.filterButton,
    FilterButtonSelectors.clearButton
  ),
  applyButton: makeSelector("Apply button", TestingAttrs.applyButton),
  cancelButton: makeSelector("Cancel button", TestingAttrs.cancelButton),
  clearButton: makeSelector("Clear button", TestingAttrs.clearButton)
};
const DsfDatePickerWrapper = (parentSelector) => WdioWrapper(parentSelector, DatePickerSelectors);
export {
  DatePickerSelectors,
  DsfDatePickerWrapper,
  TestingAttrs
};
